import fetchRequest from '@/api/api';
import type { BaseApiResponse, BaseApiResult, TeamAuthResponse, TeamCheckResponse } from '@/interfaces/service/api.interface';
import { checkHttpRequestResult } from '@/utils/api.util';

/**
 * 팀 정보를 확인합니다.
 * @param storeId 병원 ID
 */
export const checkTeam = async (storeId: number): Promise<BaseApiResult<TeamCheckResponse>> => {
  try {
    const res: BaseApiResponse<TeamCheckResponse> = await fetchRequest({
      endpoint: `/api/v1/stores/${storeId}/team`,
      method: 'GET'
    });
    return checkHttpRequestResult(res);
  } catch (error) {
    return {
      isSuccess: false,
      status: '500',
      message: '팀 정보 확인에 실패했습니다.'
    };
  }
};

/**
 * 병원과 채널 인증을 요청합니다.
 * @param storeId 병원 ID
 * @param channelId 채널 ID
 * @param accountId 계정 아이디 (선택사항)
 * @param accountPassword 계정 비밀번호 (선택사항)
 */
export const authenticateStoreChannel = async (storeId: number, channelId: string, accountId: string, accountPassword: string): Promise<BaseApiResult<TeamAuthResponse>> => {
  try {
    const res: BaseApiResponse<TeamAuthResponse> = await fetchRequest({
      endpoint: `/api/v1/stores/${storeId}/channels/${channelId}/auth`,
      method: 'POST',
      body: {
        accountId,
        accountPassword
      }
    });

    return checkHttpRequestResult(res);
  } catch (error) {
    return {
      isSuccess: false,
      status: '500',
      message: '채널 인증에 실패했습니다.'
    };
  }
};
